import Popper from 'popper.js';

/**
 * Set global so you don't have to import it
 */
window.Popper = Popper;
